import React, { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { down } from '@Globals/Style/breakpoints'

export interface IconWithLabelProps {
  children: ReactNode
  label: string
  smallTextBelowPhablet?: boolean
  smallTextBelowPhone?: boolean
}

type StyledProps = Pick<IconWithLabelProps, 'smallTextBelowPhablet' | 'smallTextBelowPhone'>

const IconWithLabelRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconWithLabelText = styled.span<StyledProps>`
  display: block;
  margin-top: 1px;
  font-size: 0.665rem;
  white-space: nowrap;

  ${({ smallTextBelowPhablet }) => smallTextBelowPhablet && css`
    ${down('phablet')} {
      padding-top: 2px;
      font-size: 0.5rem;
    }
  `};
  ${({ smallTextBelowPhone }) => smallTextBelowPhone && css`
    ${down('mobile')} {
      padding-top: 2px;
      font-size: 0.5rem;
    }
  `};
`

export const IconWithLabel: FC<IconWithLabelProps> = ({
  children,
  label,
  smallTextBelowPhablet = false,
  smallTextBelowPhone = false,
}) => (
  <IconWithLabelRoot>
    {children}
    <IconWithLabelText
      smallTextBelowPhablet={smallTextBelowPhablet}
      smallTextBelowPhone={smallTextBelowPhone}
    >
      {label}
    </IconWithLabelText>
  </IconWithLabelRoot>
)
